var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGolfProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.909871 26.1113L0.822266 26.7745H19.2087L19.4168 26.1113H0.909871Z",
    fill: "#78BA2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.05929 24.8369L0.97168 25.5001H19.3581L19.5662 24.8369H1.05929Z",
    fill: "#FBB900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.647417 27.3936L0.483154 28.0346L18.8696 28.0236L19.0886 27.3936H0.647417Z",
    fill: "#0769B7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5156 10.9078H5.27956C4.97294 10.9078 4.72107 10.6646 4.72107 10.3551C4.72107 10.322 4.72107 10.2778 4.73202 10.2446L5.17005 7.75768C5.21386 7.49241 5.44383 7.29346 5.7176 7.29346H19.5375C20.4684 7.29346 21.2349 8.06717 21.224 9.00668C21.224 9.073 21.224 9.13931 21.213 9.20563L21.2021 9.39353C21.1035 10.2557 20.3808 10.9078 19.5156 10.9078Z",
    fill: "#006AB3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9966 17.4845H3.58179L3.88841 15.7491C4.07457 14.6659 5.01635 13.8701 6.10048 13.8701H20.4023L20.3256 14.4891C20.1285 16.2023 18.6939 17.4845 16.9966 17.4845Z",
    fill: "#006AB3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6072 23.6409L2.45471 23.6962L3.04606 20.314H19.2423L18.6072 23.6409Z",
    fill: "#006AB3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07123 17.4844C7.49084 17.3517 6.92139 17.7054 6.76808 18.2802L6.45051 20.314H3.0448L3.57044 17.4844H8.07123Z",
    fill: "#006AB3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2014 9.39387L20.3911 13.8703L14.7623 14.3898L14.9266 13.8703H16.0545C16.6678 13.8703 17.1825 13.4061 17.2591 12.7982L17.3686 11.8919C17.4343 11.4055 17.0839 10.9634 16.613 10.9081C16.5802 10.9081 16.5364 10.8971 16.5035 10.8971H15.8574L16.3392 9.38281L21.2014 9.39387Z",
    fill: "#006AB3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3756 5.30665C18.8973 2.50372 25.0414 1.44789 26.5921 1.63337L26.7733 2.54691L26.4834 2.49697C25.0773 2.23041 18.2606 3.07668 11.9002 6.66003C11.0903 7.11619 10.1644 7.74273 9.31141 8.39537C8.38168 9.1243 5.45332 11.6831 5.17493 13.1675C5.62289 10.2701 10.0306 7.0049 13.3756 5.30665Z",
    fill: "#679BC1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6424 9.8181C27.6424 9.8181 27.4513 11.0358 27.2291 12.065C26.3403 12.8099 24.1769 14.1991 22.1503 14.9146C21.9966 13.824 21.3106 13.5481 20.6236 12.7561C19.5108 11.4745 19.7614 10.5225 21.2378 10.3128C25.6454 9.68882 26.7031 8.29959 27.6408 6.85881C29.3305 4.26701 28.8692 1.93652 28.8692 1.93652C31.2725 6.11398 26.9384 10.482 25.5599 11.634C25.6852 11.546 26.5047 11.0065 27.6415 9.81899L27.6424 9.8181Z",
    fill: "#0069B4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2522 5.18511C22.2993 5.05444 21.1296 5.77886 21.1127 6.90325C20.7545 7.10591 21.3481 6.74948 21.1125 6.90325C21.1127 7.33511 21.7696 7.78766 21.9524 8.17662C22.6946 8.20062 22.4664 7.96987 22.9304 7.62056H22.9313C22.9313 7.62056 22.533 7.78575 21.845 8.00174C22.0548 8.5555 22.2602 9.39204 22.5384 9.60003C23.6015 10.3911 24.5926 8.93961 24.693 7.78766C24.8343 6.20728 24.3721 5.33888 23.2522 5.18422V5.18511Z",
    fill: "#0069B4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1724 15.2391H22.079C22.2825 15.16 22.4861 15.0774 22.6905 14.9902C27.2595 13.0515 31.1521 9.19375 32.0223 6.2666C32.3868 8.9973 30.1422 12.784 27.1715 15.2391H27.1724Z",
    fill: "#679BC1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0831 2.05957C29.0831 2.05957 31.2432 2.49969 31.8405 4.10851C33.0769 7.43903 27.8895 11.2015 27.8895 11.2015C27.8895 11.2015 32.2947 7.14393 31.1481 4.48449C30.6859 3.41165 29.483 3.08175 29.483 3.08175L29.0831 2.05957Z",
    fill: "#679BC1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9625 21.3016C8.75007 21.6032 8.45269 22.1203 8.58047 22.8529C6.81817 22.337 5.26043 20.5412 5.00521 20.0369C3.26258 16.594 5.58478 12.8014 10.4147 10.1091C6.33791 12.6749 4.47165 15.7832 5.64736 18.4027C6.21215 19.6618 7.29 20.9529 8.9625 21.3016Z",
    fill: "#679BC1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11411 23.4675C9.74505 23.4675 10.2565 22.956 10.2565 22.325C10.2565 21.6941 9.74505 21.1826 9.11411 21.1826C8.48316 21.1826 7.97168 21.6941 7.97168 22.325C7.97168 22.956 8.48316 23.4675 9.11411 23.4675Z",
    fill: "url(#paint0_linear_2210_3796)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M9.29472 22.7988C9.29472 22.8986 9.21375 22.9795 9.11501 22.9795C9.01627 22.9795 8.9353 22.8986 8.9353 22.7988C8.9353 22.6991 9.01627 22.6191 9.11501 22.6191C9.21375 22.6191 9.29472 22.7001 9.29472 22.7988Z",
    fill: "url(#paint1_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M9.11589 22.6942C9.20278 22.6942 9.27585 22.7564 9.29362 22.8383C9.29658 22.8265 9.29757 22.8137 9.29757 22.8008C9.29757 22.7011 9.2166 22.6191 9.11589 22.6191C9.01517 22.6191 8.9342 22.7001 8.9342 22.8008C8.9342 22.8137 8.93519 22.8265 8.93815 22.8383C8.95494 22.7564 9.02801 22.6942 9.11589 22.6942Z",
    fill: "url(#paint2_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M8.68139 22.719C8.65967 22.7941 8.58067 22.8365 8.50563 22.8148C8.43059 22.7931 8.38813 22.7141 8.40985 22.6391C8.43158 22.564 8.51057 22.5216 8.58561 22.5433C8.66065 22.565 8.70311 22.644 8.68139 22.719Z",
    fill: "url(#paint3_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M8.57005 22.5986C8.63522 22.6173 8.6757 22.6805 8.67076 22.7457C8.6757 22.7368 8.67866 22.7279 8.68162 22.719C8.70335 22.644 8.66089 22.565 8.58585 22.5433C8.5108 22.5216 8.4328 22.564 8.41009 22.6391C8.40713 22.6489 8.40515 22.6578 8.40515 22.6677C8.43576 22.6094 8.50389 22.5798 8.56906 22.5986L8.57005 22.5986Z",
    fill: "url(#paint4_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M8.22806 22.5189C8.21029 22.5782 8.15401 22.6137 8.10167 22.5979C8.04934 22.5821 8.02071 22.5219 8.03848 22.4626C8.05625 22.4034 8.11254 22.3678 8.16487 22.3836C8.2172 22.3994 8.24584 22.4597 8.22806 22.5189Z",
    fill: "url(#paint5_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M8.15169 22.4281C8.19711 22.4419 8.22476 22.4893 8.21884 22.5406C8.2218 22.5337 8.22476 22.5268 8.22772 22.5189C8.2455 22.4597 8.21686 22.3994 8.16453 22.3836C8.1122 22.3678 8.05591 22.4034 8.03814 22.4626C8.03617 22.4705 8.03419 22.4774 8.0332 22.4853C8.0569 22.4389 8.10528 22.4142 8.1507 22.4271L8.15169 22.4281Z",
    fill: "url(#paint6_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M9.55193 22.719C9.57366 22.7941 9.65265 22.8365 9.72769 22.8148C9.80273 22.7931 9.84519 22.7141 9.82347 22.6391C9.80175 22.564 9.72275 22.5216 9.6487 22.5433C9.57365 22.565 9.5312 22.644 9.55292 22.719L9.55193 22.719Z",
    fill: "url(#paint7_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M9.66364 22.5986C9.59847 22.6173 9.55799 22.6805 9.56293 22.7457C9.55799 22.7368 9.55503 22.7279 9.55206 22.719C9.53034 22.644 9.5728 22.565 9.64784 22.5433C9.72289 22.5216 9.80089 22.564 9.8236 22.6391C9.82656 22.6489 9.82854 22.6578 9.82854 22.6677C9.79793 22.6094 9.7298 22.5798 9.66463 22.5986L9.66364 22.5986Z",
    fill: "url(#paint8_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M10.0042 22.5189C10.022 22.5782 10.0782 22.6137 10.1306 22.5979C10.1829 22.5821 10.2115 22.5219 10.1938 22.4626C10.176 22.4034 10.1197 22.3678 10.0674 22.3836C10.015 22.3994 9.98641 22.4597 10.0042 22.5189Z",
    fill: "url(#paint9_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M10.0802 22.4281C10.0348 22.4419 10.0071 22.4893 10.0131 22.5406C10.0101 22.5337 10.0071 22.5268 10.0042 22.5189C9.98641 22.4597 10.015 22.3994 10.0674 22.3836C10.1197 22.3678 10.176 22.4034 10.1938 22.4626C10.1957 22.4705 10.1977 22.4774 10.1987 22.4853C10.175 22.4389 10.1266 22.4142 10.0812 22.4271L10.0802 22.4281Z",
    fill: "url(#paint10_linear_2210_3796)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M9.25422 22.1305C9.25422 22.2085 9.19103 22.2727 9.11204 22.2727C9.03304 22.2727 8.96985 22.2095 8.96985 22.1305C8.96985 22.0515 9.03304 21.9883 9.11204 21.9883C9.19103 21.9883 9.25422 22.0515 9.25422 22.1305Z",
    fill: "url(#paint11_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M9.1123 22.0475C9.18142 22.0475 9.23869 22.0959 9.25153 22.1611C9.2535 22.1512 9.25449 22.1413 9.25449 22.1315C9.25449 22.0525 9.19031 21.9883 9.11131 21.9883C9.03232 21.9883 8.96814 22.0525 8.96814 22.1315C8.96814 22.1413 8.96913 22.1512 8.9711 22.1611C8.98493 22.0959 9.0422 22.0475 9.11033 22.0475L9.1123 22.0475Z",
    fill: "url(#paint12_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M8.77224 22.0712C8.75446 22.1305 8.69324 22.164 8.634 22.1463C8.57475 22.1285 8.54118 22.0673 8.55896 22.008C8.57673 21.9488 8.63795 21.9152 8.69719 21.933C8.75644 21.9508 8.79001 22.012 8.77224 22.0712Z",
    fill: "url(#paint13_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M8.68355 21.9773C8.73489 21.9921 8.76748 22.0415 8.76254 22.0929C8.76649 22.0859 8.76945 22.079 8.77143 22.0711C8.7892 22.0119 8.75563 21.9497 8.69639 21.9329C8.63714 21.9151 8.57592 21.9497 8.55815 22.0079C8.55617 22.0158 8.5542 22.0228 8.5542 22.0307C8.57888 21.9852 8.6322 21.9615 8.68355 21.9763L8.68355 21.9773Z",
    fill: "url(#paint14_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M8.41253 21.9102C8.39871 21.9566 8.35427 21.9842 8.3128 21.9724C8.27133 21.9605 8.24961 21.9121 8.26343 21.8657C8.27726 21.8193 8.32169 21.7917 8.36316 21.8035C8.40463 21.8154 8.42636 21.8638 8.41253 21.9102Z",
    fill: "url(#paint15_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M8.35283 21.8381C8.38837 21.8489 8.4101 21.8865 8.40615 21.9269C8.40911 21.922 8.41108 21.9161 8.41306 21.9102C8.42688 21.8638 8.40417 21.8154 8.36369 21.8035C8.32222 21.7917 8.27778 21.8193 8.26396 21.8657C8.26198 21.8717 8.261 21.8776 8.26001 21.8835C8.27877 21.847 8.31728 21.8272 8.35283 21.8381Z",
    fill: "url(#paint16_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M9.45666 22.0707C9.47443 22.13 9.53565 22.1635 9.5949 22.1458C9.65414 22.128 9.68771 22.0668 9.66994 22.0075C9.65217 21.9483 9.59095 21.9147 9.5317 21.9325C9.47246 21.9503 9.43889 22.0115 9.45666 22.0707Z",
    fill: "url(#paint17_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M9.54454 21.9768C9.4932 21.9917 9.46061 22.041 9.46555 22.0924C9.4616 22.0855 9.45864 22.0785 9.45666 22.0706C9.43889 22.0114 9.47246 21.9492 9.5317 21.9324C9.59095 21.9146 9.65217 21.9492 9.66994 22.0075C9.67192 22.0154 9.67389 22.0223 9.67389 22.0302C9.6492 21.9847 9.59589 21.961 9.54454 21.9759L9.54454 21.9768Z",
    fill: "url(#paint18_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M9.81655 21.9102C9.83038 21.9566 9.87481 21.9842 9.91628 21.9724C9.95775 21.9605 9.97948 21.9121 9.96565 21.8657C9.95183 21.8193 9.90739 21.7917 9.86592 21.8035C9.82445 21.8154 9.80273 21.8638 9.81557 21.9102L9.81655 21.9102Z",
    fill: "url(#paint19_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M9.87691 21.8381C9.84137 21.8489 9.81964 21.8865 9.82359 21.9269C9.82063 21.922 9.81866 21.9161 9.81668 21.9102C9.80286 21.8638 9.82557 21.8154 9.86605 21.8035C9.90752 21.7917 9.95196 21.8193 9.96578 21.8657C9.96776 21.8717 9.96874 21.8776 9.96973 21.8835C9.95097 21.847 9.91246 21.8272 9.87691 21.8381Z",
    fill: "url(#paint20_linear_2210_3796)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M9.21384 21.6197C9.21384 21.674 9.16941 21.7185 9.1151 21.7185C9.06079 21.7185 9.01636 21.674 9.01636 21.6197C9.01636 21.5654 9.06079 21.521 9.1151 21.521C9.16941 21.521 9.21384 21.5654 9.21384 21.6197Z",
    fill: "url(#paint21_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M9.11609 21.5625C9.16447 21.5625 9.20396 21.596 9.21384 21.6415C9.21483 21.6345 9.21581 21.6276 9.21581 21.6207C9.21581 21.5654 9.17138 21.521 9.11609 21.521C9.06079 21.521 9.01636 21.5654 9.01636 21.6207C9.01636 21.6276 9.01636 21.6345 9.01833 21.6415C9.02821 21.596 9.0677 21.5625 9.11609 21.5625Z",
    fill: "url(#paint22_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M8.87367 21.576C8.86182 21.6174 8.81837 21.6402 8.7769 21.6283C8.73543 21.6165 8.71272 21.573 8.72457 21.5315C8.73642 21.4901 8.77986 21.4674 8.82133 21.4792C8.8628 21.4911 8.88551 21.5345 8.87367 21.576Z",
    fill: "url(#paint23_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M8.81228 21.5097C8.84782 21.5206 8.87053 21.5542 8.86757 21.5907C8.87053 21.5858 8.87251 21.5808 8.8735 21.5759C8.88535 21.5344 8.86263 21.491 8.82116 21.4791C8.77969 21.4673 8.73723 21.491 8.7244 21.5315C8.72242 21.5364 8.72144 21.5423 8.72144 21.5473C8.73822 21.5157 8.77574 21.4989 8.81228 21.5097Z",
    fill: "url(#paint24_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M8.62469 21.4702C8.61482 21.5028 8.58421 21.5226 8.55557 21.5137C8.52694 21.5048 8.51114 21.4722 8.52101 21.4396C8.53089 21.407 8.5615 21.3873 8.59013 21.3962C8.61877 21.4051 8.63457 21.4376 8.62469 21.4702Z",
    fill: "url(#paint25_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M8.58199 21.4199C8.60668 21.4278 8.62248 21.4534 8.61951 21.4821C8.62149 21.4781 8.62346 21.4742 8.62445 21.4702C8.63433 21.4376 8.61853 21.4041 8.58989 21.3962C8.56126 21.3873 8.52966 21.407 8.52077 21.4396C8.51979 21.4436 8.5188 21.4475 8.5188 21.4525C8.53164 21.4268 8.55829 21.413 8.58397 21.4209L8.58199 21.4199Z",
    fill: "url(#paint26_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M9.35469 21.5755C9.36654 21.617 9.40999 21.6397 9.45146 21.6278C9.49293 21.616 9.51564 21.5725 9.50379 21.531C9.49194 21.4896 9.4485 21.4669 9.40703 21.4787C9.36556 21.4906 9.34285 21.534 9.35469 21.5755Z",
    fill: "url(#paint27_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M9.41591 21.5093C9.38037 21.5201 9.35766 21.5537 9.36062 21.5902C9.35766 21.5853 9.35568 21.5803 9.35469 21.5754C9.34285 21.5339 9.36556 21.4905 9.40703 21.4786C9.4485 21.4668 9.49096 21.4905 9.50379 21.531C9.50577 21.5359 9.50675 21.5418 9.50675 21.5468C9.48997 21.5152 9.45245 21.4984 9.41591 21.5093Z",
    fill: "url(#paint28_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M9.60512 21.4712C9.61499 21.5038 9.6456 21.5235 9.67424 21.5147C9.70287 21.5058 9.71867 21.4732 9.7088 21.4406C9.69892 21.408 9.66831 21.3883 9.63968 21.3972C9.61104 21.406 9.59525 21.4386 9.60512 21.4712Z",
    fill: "url(#paint29_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M9.64758 21.4208C9.62289 21.4287 9.60709 21.4544 9.61006 21.4831C9.60808 21.4791 9.60611 21.4752 9.60512 21.4712C9.59525 21.4386 9.61104 21.4051 9.63968 21.3972C9.66831 21.3883 9.69991 21.408 9.7088 21.4406C9.70978 21.4445 9.71077 21.4485 9.71077 21.4534C9.69794 21.4278 9.67128 21.4139 9.6456 21.4218L9.64758 21.4208Z",
    fill: "url(#paint30_linear_2210_3796)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M8.97846 22.396C8.97846 22.4711 8.91724 22.5323 8.84219 22.5323C8.76715 22.5323 8.70593 22.4711 8.70593 22.396C8.70593 22.321 8.76715 22.2598 8.84219 22.2598C8.91724 22.2598 8.97846 22.321 8.97846 22.396Z",
    fill: "url(#paint31_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M8.84318 22.317C8.90934 22.317 8.96463 22.3634 8.97747 22.4256C8.97944 22.4168 8.98043 22.4069 8.98043 22.397C8.98043 22.321 8.91921 22.2598 8.84318 22.2598C8.76715 22.2598 8.70593 22.321 8.70593 22.397C8.70593 22.4069 8.70692 22.4158 8.70889 22.4256C8.72173 22.3634 8.77703 22.317 8.84318 22.317Z",
    fill: "url(#paint32_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M9.52374 22.397C9.52374 22.472 9.46253 22.5333 9.38748 22.5333C9.31244 22.5333 9.25122 22.472 9.25122 22.397C9.25122 22.322 9.31244 22.2607 9.38748 22.2607C9.46253 22.2607 9.52374 22.322 9.52374 22.397Z",
    fill: "url(#paint33_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M9.38847 22.318C9.45463 22.318 9.50992 22.3644 9.52276 22.4266C9.52473 22.4177 9.52572 22.4079 9.52572 22.398C9.52572 22.322 9.4645 22.2607 9.38847 22.2607C9.31244 22.2607 9.25122 22.322 9.25122 22.398C9.25122 22.4079 9.25221 22.4168 9.25418 22.4266C9.26702 22.3644 9.32231 22.318 9.38847 22.318Z",
    fill: "url(#paint34_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M8.51087 22.3268C8.49409 22.3831 8.43583 22.4147 8.37955 22.3989C8.32327 22.3821 8.29167 22.3238 8.30846 22.2675C8.32524 22.2113 8.3835 22.1797 8.43978 22.1955C8.49606 22.2123 8.52766 22.2705 8.51087 22.3268Z",
    fill: "url(#paint35_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M8.42665 22.2373C8.47602 22.2521 8.50663 22.2985 8.50169 22.3479C8.50465 22.342 8.50762 22.335 8.50959 22.3271C8.52638 22.2709 8.49379 22.2116 8.4385 22.1958C8.38222 22.179 8.32396 22.2116 8.30717 22.2679C8.3052 22.2748 8.30421 22.2827 8.30322 22.2896C8.32692 22.2462 8.37728 22.2235 8.42665 22.2383L8.42665 22.2373Z",
    fill: "url(#paint36_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M8.17021 22.1885C8.15639 22.2339 8.11294 22.2615 8.07345 22.2497C8.03395 22.2378 8.01124 22.1914 8.02506 22.146C8.03889 22.1006 8.08233 22.0729 8.12183 22.0848C8.16231 22.0966 8.18404 22.143 8.17021 22.1885Z",
    fill: "url(#paint37_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M8.11085 22.1183C8.1464 22.1282 8.16713 22.1657 8.16318 22.2052C8.16614 22.2003 8.16812 22.1944 8.17009 22.1885C8.18392 22.143 8.16219 22.0966 8.12171 22.0848C8.08123 22.0729 8.03778 22.1006 8.02396 22.146C8.02198 22.1519 8.021 22.1578 8.021 22.1638C8.03877 22.1282 8.07629 22.1085 8.11184 22.1193L8.11085 22.1183Z",
    fill: "url(#paint38_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M9.71988 22.3273C9.73667 22.3836 9.79492 22.4152 9.85121 22.3994C9.90749 22.3826 9.93909 22.3243 9.92329 22.268C9.90749 22.2118 9.84824 22.1802 9.79196 22.196C9.73568 22.2127 9.70408 22.271 9.71988 22.3273Z",
    fill: "url(#paint39_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M9.80501 22.2378C9.75564 22.2526 9.72504 22.299 9.72997 22.3484C9.72701 22.3424 9.72405 22.3355 9.72207 22.3276C9.70529 22.2714 9.73787 22.2121 9.79317 22.1963C9.84945 22.1795 9.9077 22.2121 9.92449 22.2684C9.92647 22.2753 9.92745 22.2832 9.92844 22.2901C9.90474 22.2467 9.85438 22.224 9.80501 22.2388L9.80501 22.2378Z",
    fill: "url(#paint40_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M10.0603 22.1885C10.0742 22.2339 10.1176 22.2615 10.1571 22.2497C10.1976 22.2378 10.2193 22.1914 10.2055 22.146C10.1917 22.1006 10.1482 22.0729 10.1087 22.0848C10.0692 22.0966 10.0465 22.143 10.0603 22.1885Z",
    fill: "url(#paint41_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M10.1183 22.1183C10.0828 22.1282 10.0621 22.1657 10.066 22.2052C10.063 22.2003 10.0611 22.1944 10.0591 22.1885C10.0453 22.143 10.067 22.0966 10.1075 22.0848C10.148 22.0729 10.1914 22.1006 10.2052 22.146C10.2072 22.1519 10.2082 22.1578 10.2082 22.1638C10.1904 22.1282 10.1529 22.1085 10.1174 22.1193L10.1183 22.1183Z",
    fill: "url(#paint42_linear_2210_3796)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M8.90617 21.932C8.96343 21.932 9.00985 21.8855 9.00985 21.8283C9.00985 21.771 8.96343 21.7246 8.90617 21.7246C8.84891 21.7246 8.80249 21.771 8.80249 21.8283C8.80249 21.8855 8.84891 21.932 8.90617 21.932Z",
    fill: "url(#paint43_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M8.90716 21.7681C8.95751 21.7681 8.99997 21.8036 9.00985 21.851C9.01083 21.8441 9.01182 21.8372 9.01182 21.8293C9.01182 21.771 8.96541 21.7246 8.90716 21.7246C8.8489 21.7246 8.80249 21.771 8.80249 21.8293C8.80249 21.8362 8.80249 21.8441 8.80447 21.851C8.81434 21.8036 8.8568 21.7681 8.90716 21.7681Z",
    fill: "url(#paint44_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M9.32182 21.932C9.37908 21.932 9.42549 21.8855 9.42549 21.8283C9.42549 21.771 9.37908 21.7246 9.32182 21.7246C9.26456 21.7246 9.21814 21.771 9.21814 21.8283C9.21814 21.8855 9.26456 21.932 9.32182 21.932Z",
    fill: "url(#paint45_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M9.32207 21.7681C9.37243 21.7681 9.41489 21.8036 9.42476 21.851C9.42575 21.8441 9.42674 21.8372 9.42674 21.8293C9.42674 21.771 9.38033 21.7246 9.32207 21.7246C9.26382 21.7246 9.21741 21.771 9.21741 21.8293C9.21741 21.8362 9.21741 21.8441 9.21938 21.851C9.22926 21.8036 9.27172 21.7681 9.32207 21.7681Z",
    fill: "url(#paint46_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M8.65452 21.7784C8.64168 21.8209 8.59725 21.8456 8.5538 21.8327C8.51134 21.8199 8.48666 21.7755 8.49949 21.732C8.51233 21.6896 8.55676 21.6649 8.59922 21.6777C8.64168 21.6906 8.66637 21.735 8.65353 21.7784L8.65452 21.7784Z",
    fill: "url(#paint47_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M8.58905 21.7103C8.62657 21.7212 8.64928 21.7567 8.64632 21.7942C8.64928 21.7893 8.65126 21.7844 8.65225 21.7784C8.66508 21.736 8.6404 21.6905 8.59794 21.6777C8.55548 21.6649 8.51006 21.6896 8.49722 21.733C8.49525 21.7389 8.49426 21.7439 8.49426 21.7498C8.51204 21.7162 8.55054 21.6994 8.58807 21.7103L8.58905 21.7103Z",
    fill: "url(#paint48_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M8.39212 21.6704C8.38224 21.705 8.34867 21.7257 8.31806 21.7168C8.28745 21.7079 8.27067 21.6724 8.28054 21.6378C8.29041 21.6033 8.32399 21.5825 8.3546 21.5914C8.38521 21.6003 8.40199 21.6358 8.39212 21.6704Z",
    fill: "url(#paint49_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M8.34782 21.6171C8.37448 21.625 8.39027 21.6526 8.38731 21.6832C8.38929 21.6793 8.39126 21.6753 8.39225 21.6704C8.40212 21.6358 8.38632 21.6003 8.35473 21.5914C8.32412 21.5825 8.29055 21.6033 8.28067 21.6378C8.27968 21.6418 8.2787 21.6467 8.27771 21.6507C8.29153 21.624 8.32017 21.6092 8.34683 21.6171L8.34782 21.6171Z",
    fill: "url(#paint50_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M9.57335 21.7784C9.58618 21.8209 9.63062 21.8456 9.67307 21.8327C9.71553 21.8199 9.74022 21.7755 9.72738 21.732C9.71454 21.6896 9.67011 21.6649 9.62765 21.6777C9.5852 21.6906 9.56051 21.735 9.57335 21.7784Z",
    fill: "url(#paint51_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M9.63654 21.7103C9.59902 21.7212 9.57631 21.7567 9.57927 21.7942C9.57631 21.7893 9.57433 21.7844 9.57335 21.7784C9.56051 21.736 9.58519 21.6905 9.62765 21.6777C9.67011 21.6649 9.71553 21.6896 9.72837 21.733C9.73034 21.7389 9.73133 21.7439 9.73133 21.7498C9.71356 21.7162 9.67505 21.6994 9.63753 21.7103L9.63654 21.7103Z",
    fill: "url(#paint52_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M9.83462 21.6704C9.84449 21.705 9.87806 21.7257 9.90867 21.7168C9.93928 21.7079 9.95607 21.6724 9.94619 21.6378C9.93632 21.6033 9.90275 21.5825 9.87214 21.5914C9.84153 21.6003 9.82474 21.6358 9.83462 21.6704Z",
    fill: "url(#paint53_linear_2210_3796)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M9.88012 21.6171C9.85346 21.625 9.83766 21.6526 9.84062 21.6832C9.83865 21.6793 9.83667 21.6753 9.83569 21.6704C9.82581 21.6358 9.84161 21.6003 9.87321 21.5914C9.90382 21.5825 9.93739 21.6033 9.94726 21.6378C9.94825 21.6418 9.94924 21.6467 9.95023 21.6507C9.9364 21.624 9.90777 21.6092 9.88111 21.6171L9.88012 21.6171Z",
    fill: "url(#paint54_linear_2210_3796)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1,
    d: "M4.42014 21.0327C3.83066 21.0327 3.34683 20.5864 3.28462 20.0146C3.28067 20.0551 3.27771 20.0966 3.27771 20.1381C3.27771 20.769 3.78919 21.2805 4.42014 21.2805C5.05109 21.2805 5.56257 20.769 5.56257 20.1381C5.56257 20.0966 5.56059 20.0551 5.55566 20.0146C5.49345 20.5873 5.00962 21.0327 4.42014 21.0327Z",
    fill: "url(#paint55_linear_2210_3796)"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0722 0.832521C28.6391 0.991425 28.7792 1.83434 28.8112 2.28107L28.8135 2.28283C28.8697 3.06652 28.6784 4.18363 28.6784 4.18363C28.6694 3.79474 28.4718 3.20253 28.0287 3.00117C27.6615 2.83466 27.2204 2.89508 26.9152 2.52648C26.8785 2.4821 26.8468 2.43543 26.8193 2.38752C26.5446 1.77286 26.4105 0.601334 28.0722 0.832521Z",
    fill: "#0069B4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2210_3796",
    x1: 9.11411,
    y1: 21.2014,
    x2: 9.11411,
    y2: 23.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FAFCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EFF6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#DEECFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C5DEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2210_3796",
    x1: 8.75066,
    y1: 21.1884,
    x2: 9.02022,
    y2: 22.3802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2210_3796",
    x1: 8.75055,
    y1: 21.1894,
    x2: 9.0211,
    y2: 22.3802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2210_3796",
    x1: 8.56582,
    y1: 22.3812,
    x2: 8.4875,
    y2: 23.6005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2210_3796",
    x1: 8.59309,
    y1: 22.3986,
    x2: 8.51483,
    y2: 23.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2210_3796",
    x1: 8.17824,
    y1: 22.0429,
    x2: 8.13253,
    y2: 23.2552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2210_3796",
    x1: 8.16357,
    y1: 22.037,
    x2: 8.12138,
    y2: 23.2486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2210_3796",
    x1: 9.63232,
    y1: 21.8352,
    x2: 9.71037,
    y2: 23.0537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2210_3796",
    x1: 10.1142,
    y1: 21.6323,
    x2: 10.19,
    y2: 22.8512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2210_3796",
    x1: 9.62902,
    y1: 21.8578,
    x2: 9.67474,
    y2: 23.0702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2210_3796",
    x1: 10.1468,
    y1: 21.6346,
    x2: 10.1893,
    y2: 22.8472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2210_3796",
    x1: 8.89184,
    y1: 21.1549,
    x2: 9.16141,
    y2: 22.3467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2210_3796",
    x1: 8.89112,
    y1: 21.1549,
    x2: 9.16068,
    y2: 22.3457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2210_3796",
    x1: 8.64342,
    y1: 22.389,
    x2: 8.56538,
    y2: 23.6074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2210_3796",
    x1: 8.67091,
    y1: 22.4064,
    x2: 8.59265,
    y2: 23.6248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2210_3796",
    x1: 8.32999,
    y1: 22.0482,
    x2: 8.28427,
    y2: 23.2605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2210_3796",
    x1: 8.31356,
    y1: 22.0408,
    x2: 8.27244,
    y2: 23.2526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2210_3796",
    x1: 9.54903,
    y1: 21.8416,
    x2: 9.62708,
    y2: 23.0601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2210_3796",
    x1: 10.0318,
    y1: 21.6403,
    x2: 10.1073,
    y2: 22.8583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2210_3796",
    x1: 9.47412,
    y1: 21.8632,
    x2: 9.51983,
    y2: 23.0755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2210_3796",
    x1: 9.99364,
    y1: 21.6384,
    x2: 10.0361,
    y2: 22.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2210_3796",
    x1: 9.00451,
    y1: 21.1339,
    x2: 9.27506,
    y2: 22.3247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2210_3796",
    x1: 9.0055,
    y1: 21.1349,
    x2: 9.27506,
    y2: 22.3257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2210_3796",
    x1: 8.74642,
    y1: 22.3954,
    x2: 8.66809,
    y2: 23.6148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2210_3796",
    x1: 8.77355,
    y1: 22.4119,
    x2: 8.69501,
    y2: 23.6313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2210_3796",
    x1: 8.52463,
    y1: 22.0633,
    x2: 8.47891,
    y2: 23.2756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2210_3796",
    x1: 8.50835,
    y1: 22.0558,
    x2: 8.46616,
    y2: 23.2674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2210_3796",
    x1: 9.44677,
    y1: 21.849,
    x2: 9.52482,
    y2: 23.0675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2210_3796",
    x1: 9.93021,
    y1: 21.6455,
    x2: 10.0061,
    y2: 22.8645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2210_3796",
    x1: 9.27992,
    y1: 21.8783,
    x2: 9.32591,
    y2: 23.0916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2210_3796",
    x1: 9.79968,
    y1: 21.6544,
    x2: 9.84214,
    y2: 22.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2210_3796",
    x1: 8.57856,
    y1: 21.2309,
    x2: 8.84812,
    y2: 22.4217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2210_3796",
    x1: 8.57856,
    y1: 21.2319,
    x2: 8.84812,
    y2: 22.4227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2210_3796",
    x1: 9.09719,
    y1: 21.1144,
    x2: 9.36675,
    y2: 22.3052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2210_3796",
    x1: 9.09817,
    y1: 21.1154,
    x2: 9.36773,
    y2: 22.3062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2210_3796",
    x1: 8.40525,
    y1: 22.3713,
    x2: 8.3272,
    y2: 23.5897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2210_3796",
    x1: 8.43131,
    y1: 22.3888,
    x2: 8.35277,
    y2: 23.6082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2210_3796",
    x1: 8.11265,
    y1: 22.0441,
    x2: 8.06666,
    y2: 23.2574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2210_3796",
    x1: 8.09888,
    y1: 22.0385,
    x2: 8.05642,
    y2: 23.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2210_3796",
    x1: 9.78678,
    y1: 21.7809,
    x2: 9.86511,
    y2: 23.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2210_3796",
    x1: 10.2571,
    y1: 21.5868,
    x2: 10.3327,
    y2: 22.8048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2210_3796",
    x1: 9.70092,
    y1: 21.8308,
    x2: 9.74664,
    y2: 23.0431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2210_3796",
    x1: 10.2039,
    y1: 21.6155,
    x2: 10.2461,
    y2: 22.8271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2210_3796",
    x1: 8.76102,
    y1: 21.1865,
    x2: 9.03058,
    y2: 22.3773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2210_3796",
    x1: 8.76201,
    y1: 21.1865,
    x2: 9.03157,
    y2: 22.3783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2210_3796",
    x1: 9.15593,
    y1: 21.0966,
    x2: 9.42549,
    y2: 22.2874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2210_3796",
    x1: 9.15619,
    y1: 21.0976,
    x2: 9.42674,
    y2: 22.2884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2210_3796",
    x1: 8.53817,
    y1: 22.3801,
    x2: 8.45984,
    y2: 23.5995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2210_3796",
    x1: 8.56296,
    y1: 22.3982,
    x2: 8.4847,
    y2: 23.6166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2210_3796",
    x1: 8.30701,
    y1: 22.049,
    x2: 8.26101,
    y2: 23.2623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2210_3796",
    x1: 8.29227,
    y1: 22.043,
    x2: 8.25008,
    y2: 23.2546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2210_3796",
    x1: 9.65196,
    y1: 21.7892,
    x2: 9.72934,
    y2: 23.0089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2210_3796",
    x1: 10.1214,
    y1: 21.5944,
    x2: 10.1972,
    y2: 22.8133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2210_3796",
    x1: 9.50373,
    y1: 21.8357,
    x2: 9.54945,
    y2: 23.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2210_3796",
    x1: 10.008,
    y1: 21.619,
    x2: 10.0505,
    y2: 22.8316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2210_3796",
    x1: 4.42014,
    y1: 20.8125,
    x2: 4.42014,
    y2: 21.2341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolfProject);
export default __webpack_public_path__ + "static/media/golfProject.56f781af438143cf5d3af48054424139.svg";
export { ForwardRef as ReactComponent };